module.exports = __webpack_public_path__ + "img/IMG_20190924_112310.872e24e1.jpg";